import compPay from "./components/compPay.vue";
import { getGameServerMap } from "@/utils/dictionary";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import serverList from "../../components/serverList/serverOptions.vue";
export default {
  components: {
    compPay: compPay,
    timeDateOptions: timeDateOptions,
    serverList: serverList
  },
  name: "payLog",
  data: function data() {
    return {
      serverList: {},
      orderStatus: [{
        label: "已发货",
        value: 1
      }, {
        label: "所有订单",
        value: 2
      }],
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      searchInfo: {
        status: 2,
        server_id: []
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      getGameServerMap().then(function (res) {
        _this.serverList = res;
      });
    },
    queryEvent: function queryEvent(e) {
      this.searchInfo.sdate = this.timedata[0];
      this.searchInfo.edate = this.timedata[1];
      if (e == "search") {
        this.$refs.myChild.goMethod("1", this.searchInfo);
      } else {
        this.$refs.myChild.goMethod("2", this.searchInfo);
      }
    }
  }
};